var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_box"},[_c('div',{staticClass:"page_table_box",staticStyle:{"height":"calc(100% - 10px)","overflow-y":"scroll","scrollbar-width":"none"}},[(_vm.planInfo.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.planInfo.content)}}):_c('div',{staticClass:"work_guide_content"},[_c('div',[_vm._v("暂无内容")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }